// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__zxmNY","errorText":"ErrorPage_errorText__PdGol","errorButton":"ErrorPage_errorButton__giig2"};